import { navigate, RouteComponentProps } from '@reach/router';
import React, { Component } from 'react';

import Button from '../../../../components/Button';
import { FormConsumer, FormProvider, IFormAttributes } from '../../../../components/Forms';
import Input from '../../../../components/Input';
import { withContext } from '../../../../contrib/utils';
import { IAdminClubActions } from '../../../../store/admin/clubs/actions';
import { IClubCreationForm } from '../../../../store/admin/clubs/store';

interface IState {
  invalidEmail: boolean;
  invalidEmailMessage: string;
}

interface IProps extends RouteComponentProps {
  actions: { adminClubs: IAdminClubActions };
  admin: any;
}

export class CreateClubComponent extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      invalidEmail: false,
      invalidEmailMessage: ''
    };

    this.onSubmit = this.onSubmit.bind(this);
  }

  public onSubmit(): (data: IClubCreationForm) => Promise<void> {
    return async (data: IClubCreationForm) => {
      const response = await this.props.actions.adminClubs.create(data);
      if (response && response.errors) {
        this.setState({ invalidEmail: true, invalidEmailMessage: response.errors.auth.msg || '' });
      } else {
        const currentClub =
          response.adminClubs && response.adminClubs.current
            ? response.adminClubs.current
            : { id: -1 };
        navigate(`/staff/club/create/${currentClub.id}/season`);
      }
    };
  }

  public render(): JSX.Element {
    return (
      <div>
        <FormProvider
          defaultValues={{}}
          onSubmit={this.onSubmit()}
          validations={{
            name: 'required'
          }}
        >
          <FormConsumer>
            {({ values, formActions: { setValue }, errors }: IFormAttributes) => (
              <div className="create-club form">
                <h1 className="create-club__title override">GENERAL CLUB DETAILS</h1>
                <p className="help-text">
                  Don't worry, you can always change this information later.
                </p>
                <Input
                  label="CLUB NAME"
                  id="club-name"
                  type="text"
                  value={values.name}
                  onChange={setValue('name')}
                  hasError={errors.name}
                  errorMessage="Club Name cannot be empty"
                  fullWidth={true}
                />
                <Button
                  className="create-club__next-button button--shadow"
                  variant="contained"
                  color="primary"
                  disabled={errors.FORM || (values.name === '' || values.name === undefined)}
                  type="submit"
                  size="large"
                >
                  NEXT
                </Button>
              </div>
            )}
          </FormConsumer>
        </FormProvider>
      </div>
    );
  }
}

const CreateClub = withContext(CreateClubComponent, 'admin');

export { CreateClub };
